{
  "version": 1,
  "asset_id": "480eccc9-6a09-4fa3-a653-6659ba50d76a",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/480eccc9-6a09-4fa3-a653-6659ba50d76a/ind-ecommerce-1200.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/480eccc9-6a09-4fa3-a653-6659ba50d76a/ind-ecommerce-1200.webp",
  "original_filename": "ind-ecommerce-1200.webp",
  "size": 17246,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:01Z"
}
